export default function classesToSelector(classes = '') {
  return `.${classes
    .trim()
    .replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}



// WEBPACK FOOTER //
// ../src/shared/classes-to-selector.js